/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import api from 'app/redux/api.js';
import { AppActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const bootstrapAppEpic = (action$, state$) => action$.pipe(
    ofType(constants.APP_LOADING),
    mergeMap(action => api('/config', state$, null, null, AppActions.appReady))
);

export const loginUserEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.APP_LOGIN_USER && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, AppActions.loginUserResult))
);

export const createUserEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.APP_CREATE_USER && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, AppActions.createUserResult))
);

export const autologinEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.APP_AUTOLOGIN && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, AppActions.autologinResult))
);

export const checkUserEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.APP_CHECK_USER && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, AppActions.checkUserStateResult))
);
